import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';
import { StudentItemViewModel } from 'src/app/models/student.model';

@Component({
  selector: 'app-new-student-item',
  templateUrl: './new-student-item.component.html',
  styleUrls: ['./new-student-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, IonButton]
})
export class NewStudentItemComponent {
  @Input()
  student: StudentItemViewModel;
  @Input()
  showAttendance: boolean;
  @Output()
  selectStudent = new EventEmitter<number>();

  studentClicked(event): void {
    // Deselect the button
    (document.activeElement as HTMLElement).blur();

    event.stopPropagation();
    this.selectStudent.emit(this.student.id);
  }
}
